import React from 'react'

import {classes} from './styles'

type Props = {
  description?: string
  swap?: boolean
}

const Item: React.FC<React.PropsWithChildren<Props>> = ({description, children, swap}) => {
  return (
    <div className={classes.item}>
      {swap ? (
        <>
          {description && <div className={classes.secondary}>{description}</div>}
          <div className={classes.primary}>{children}</div>
        </>
      ) : (
        <>
          <div className={classes.primary}>{children}</div>
          {description && <div className={classes.secondary}>{description}</div>}
        </>
      )}
    </div>
  )
}

export default Item
